import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClose(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path stroke="currentColor" strokeLinecap="round" d="m5 5 6 6m0-6-6 6" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
